import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  data () {
    return {
      basicInfoPermissions: {}
    }
  },

  computed: {
    groupConfig () {
      return {
        title: this.$t('fleet/vehicle/basic_info_tab.tab_label'),
        key: 'group',
        apiConfig: {
          post: {
            module: 'fleet',
            route: this.createMode ? 'groups' : `groups/${this.$route.params.id}`
          }
        },
        validationErrors: this.validationErrors,
        afterSave: () => {
          this.createMode = false
        },
        onDataReceived: (event) => {
          this.basicInfoPermissions = event?.meta?.permissions || {}
        },
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base.back'),
            showBackButton: {
              onGoBack: () => this.onGoToFleetGroupsOverview()
            },
            showEditBtn: getBooleanFromValue(this.basicInfoPermissions?.canUpdate),
            onCancelTabSave: (event) => {
              const { cancelTabSave } = event || {}
              if (this.createMode) {
                this.createMode = false
              }
              else {
                cancelTabSave()
              }
            },
            onSaveClick: async (event) => {
              const { saveTab } = event || {}
              if (typeof saveTab === 'function') {
                await saveTab()
              }
            }
          },
          {
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.basicInfoPermissions?.canUpdate),
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('fleet/vehicle_document.name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  watch: {
    createMode: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.$set(this.groupConfig.apiConfig, 'get', {
            module: 'fleet',
            route: `groups/${this.$route.params.id}`,
            method: 'get'
          })
        }
        else {
          this.$delete(this.groupConfig.apiConfig, 'get')
        }
      }
    }
  },

  methods: {
    onGoToFleetGroupsOverview () {
      if (this.createMode) {
        this.createMode = false
      }
      else {
        this.$router.push({
          name: 'FleetGroups'
        }).then()
      }
    }
  }
}
